export const objectHelper = {
  isFunction(target: any) {
    return typeof target === 'function';
  }
};